import { AxiosResponse } from 'axios';

import { BulkInvoiceTotalDto, ServiceResult } from '../../../types';
import authNetworkService from '../auth-network/auth-network.service';
import paymentPartnerUrls from './admin-payment-partners.urls';

const getPaymentPartnerReferenceTotal = (paymentPartnerReference: string): Promise<number> => {
  const url = paymentPartnerUrls.getTotal(paymentPartnerReference);

  return authNetworkService.get(url).then((apiResponse: AxiosResponse<ServiceResult<number>>) => {
    return apiResponse.data.data;
  });
};

const getPaymentPartnerReferenceTotals = (
  paymentPartnerReferenceNumbers: string[],
): Promise<BulkInvoiceTotalDto[]> => {
  const url = paymentPartnerUrls.getTotals;

  return authNetworkService
    .post(url, { paymentPartnerReferenceNumbers })
    .then((apiResponse: AxiosResponse<ServiceResult<BulkInvoiceTotalDto[]>>) => {
      return apiResponse.data.data;
    });
};

const settleFines = (paymentPartnerReference: string) => {
  const url = paymentPartnerUrls.settleFines(paymentPartnerReference);

  return authNetworkService.post(url);
};

const settleFinesBulk = (paymentPartnerReferenceNumbers: string[]) => {
  const url = paymentPartnerUrls.settleFinesBulk;

  return authNetworkService.post(url, { paymentPartnerReferenceNumbers });
};

export default {
  getPaymentPartnerReferenceTotals,
  getPaymentPartnerReferenceTotal,
  settleFinesBulk,
  settleFines,
};
